/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournaments_Filter_FromInputs */



/**
* | output |
* | --- |
* | "From" |
*
* @param {Tournaments_Filter_FromInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournaments_filter_from = /** @type {((inputs?: Tournaments_Filter_FromInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournaments_Filter_FromInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Du")
	if (locale === "es") return /** @type {LocalizedString} */ ("Desde")
	if (locale === "pt") return /** @type {LocalizedString} */ ("De")
	if (locale === "it") return /** @type {LocalizedString} */ ("Dal")
	return /** @type {LocalizedString} */ ("From")
});